// extracted by mini-css-extract-plugin
export default {"container":"Card_container__dnP0k","chips":"Card_chips__9SWgl","checkIcon":"Card_checkIcon__4NMXi","border":"Card_border__2rBC6"};